import React from 'react';
import logo from '../../../static/img/planz-logo-white.svg';

const Logo = () =>
  (
    <a className="navbar-brand">
      <img
        alt=""
        src={logo}
        width="88"
        height="30"
        className="d-inline-block align-top"
        style={{ paddingTop: 0 }}
      />
    </a>
  );

export default Logo;



// WEBPACK FOOTER //
// ./src/components/ui/Logo/Logo.js